var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchLayout',{attrs:{"get-data":_vm.readUrlsByKeyword()}})
}
var staticRenderFns = []

export { render, staticRenderFns }